module.exports = __webpack_public_path__ + "img/review-hsia.adf0525a.webp";